import React from 'react';
import styled from 'styled-components';
import { ListGroup } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Fields } from 'utils/filtros';

import FilterItem from './components/FilterItem';
import RangePicker from './components/RangePicker';

const SideNav = styled.nav``;

const Label = styled.span``;

const ListItem = styled(ListGroup.Item)`
  border: none;
  background: transparent;
`;

const Title = styled.h2`
  font-size: 28px;
  margin-left: 20px;
`;

const Sidebar = () => {
  const constantes = useSelector(state => state.constantes);

  return (
    <SideNav>
      <ListGroup>
        <Title>Filtros</Title>
        <ListItem>
          <FilterItem
            field={Fields.areasDeAtuacao}
            label="Área de atuação"
            data={constantes.areas_de_atuacao}
          />
        </ListItem>
        <ListItem>
          <FilterItem
            field={Fields.nivelDeEscolaridade}
            label="Nível de escolaride"
            data={constantes.nivel_de_escolaridade}
          />
        </ListItem>
        <ListItem>
          <FilterItem
            field={Fields.regimeDeContratacao}
            label="Regime de contratação"
            data={constantes.regime_de_contratacao}
          />
        </ListItem>
        <ListItem>
          <Label>Salário</Label>
          <RangePicker />
        </ListItem>
      </ListGroup>
    </SideNav>
  );
};

export default Sidebar;
